<template>
  <div>
  <right-panel :datas="connects" :items="connects" @onClose="onClose" @onSubmit="onSubmitForm" ref="right-panel">
    <div slot="header">
      <translate>Create WorkGroup</translate>
    </div>
  </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'WorkgroupAdd',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null
      }
    },
    methods: {
      onSubmitForm () {
        let params = Object.assign({}, this.$refs['right-panel'].profileModel)
        this.$store.dispatch(STORE_CONST.WORKGROUP.CREATED_WORKGROUP, params).then(() => {
          this.$notify({
            type: 'success',
            message: this.$gettext('Create workgroup success')
          })
          this.$emit('callback')
          this.$refs['right-panel'].onClose()
        }).catch(err => {
          this.$refs['right-panel'].onSubmitErr()
          console.log(err, err)
        })
      },
      // 关闭创建集群
      onClose () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// workgroup-add.vue?3f9139a4